@use "foundation/colors";
@use "foundation/responsive";
@use "./shared" as shared;

.cancel_confirmation {
  @include shared.screen-container;

  h1 {
    margin: 40px auto;

    @include responsive.phone {
      margin: 24px auto;
    }
  }
}

.description {
  @include shared.description;
}

.checkmark {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  margin: 80px auto 0;
  background-color: colors.$primary-white;
  border-radius: 50%;

  svg {
    width: 100%;
    height: 100%;
    fill: colors.$primary-white;
  }

  @include responsive.phone {
    width: 64px;
    height: 64px;
    margin-top: 32px;
  }
}
